import { Component, Input } from '@angular/core';
import { LanguageService } from "../../services/language.service";

@Component({
  selector: 'app-load-panel',
  templateUrl: './load-panel.component.html',
  styleUrls: ['./load-panel.component.css']
})
export class LoadPanelComponent {
  constructor(public languageService: LanguageService) {}
}
